import { RecoilState, useRecoilState } from "recoil";

interface IDisclosure {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  onToggle: () => void;
}

export function useRecoilDisclosure(
  disclosureAtom: RecoilState<any>,
): IDisclosure {
  const [isOpen, setIsOpen] = useRecoilState(disclosureAtom);
  const onClose = () => setIsOpen(false);
  const onOpen = () => setIsOpen(true);
  const onToggle = () => setIsOpen(!isOpen);
  return { isOpen, onOpen, onClose, onToggle };
}
